import { render, staticRenderFns } from "./campos.opcao.vue?vue&type=template&id=57fa9408&"
import script from "./campos.opcao.vue?vue&type=script&lang=js&"
export * from "./campos.opcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports